<template>
	<article class="campaign-list">
		<section class="col-md-12 col-sm-12 col-xs-12 product-top" style="padding: 0;">
			<div class="campaign-list-heading">
				<header>
					<ximg
						:src="iconImage"
						ariaLabel="campaign icon"
						role="img"
					/>
					<h1 v-if="selectedSection">
						{{ selectedSection.name }}
					</h1>
					<h1 v-else>
						Alla kampanjer
					</h1>
				</header>
				<dropdown v-if="mobileView" v-model="sectionSelector" class="mb-5">
					<a slot="label">
						{{ sectionSelectorLabel }}
					</a>
					<ul class="dropdown-menu campaign-sections">
						<li
							v-for="(sectionItem, index) in sectionDropdownItems"
							:key="'section-item-' + index"
						>
							<a @click="selectSection(sectionItem.value)">
								<ximg
									:src="sectionIconUrl(sectionItem.icon)"
									:ariaLabel="sectionItem.label"
									role="img"
								/>
								{{ sectionItem.label }}
							</a>
						</li>
					</ul>
				</dropdown>
				<div v-if="highlights && highlights.length" class="d-flex mb-4">
					<p class="secondary">
						Här listar vi alla våra aktiva kampanjer{{ selectedSection ? ' under ' + selectedSection.name : '' }}.
						<span v-if="! mobileView && ! selectedSection">Välj avdelning i menyn.</span>
					</p>
				</div>
			</div>
			<highlight-section
				v-if="highlights && highlights.length"
				ref="highlightSection"
				:highlightSection="highlightSection"
				:highlightsPerPage="highlightsPerPage"
				verticalPagination
				paginate
			/>
			<h2>Återkommande kampanjer</h2>
			<ul>
				<li
					v-for="(campaign, index) in recurringCampaigns"
					:key="'recurring-campaigns-' + index"
				>
					<a-link
						:to="standardRoute('campaign', campaign)"
						:key="'recurring-campaigns-link-' + index"
					>
						{{ campaign.title }}
					</a-link>
				</li>
			</ul>
			<hr />
			<header>
				<h2>Populära erbjudanden</h2>
			</header>
			<product-browser
				v-if="resetData.length"
				ref="browser"
				:layoutOptions="browserLayoutOptions"
				:url="url"
				:resetData="resetData"
				@loaded="onProductsLoad"
			/>
		</section>
		<div class="clearfix"></div>
	</article>
</template>
<script>
import bus from 'eventbus';
import mq from 'mediaQuery';
import router from 'router';
import store from 'datastore';
import { mapState } from 'vuex';
import metaHandler from 'metaHandler';
import { sectionIds, recurringCampaigns } from 'staticData';
import { categoryIconUrl, convertToCdnUrl, standardRoute } from 'utils';
import { setCustomNav } from 'datastore/navStatus';

export default {
	layoutOptions: {
		leftCol: true,
	},
	store,
	handlesPrerender: true,
	handleNavigation () {
		return true;
	},
	data () {
		return {
			mq,
			categoryIconUrl,
			convertToCdnUrl,
			recurringCampaigns,
			standardRoute,
			highlights: [],
			products: [],
			browserLayoutOptions: {
				compactLayout: false,
				compactThreshold: 99999,
				resetFiltersOnResize: false,
			},
			selectedSectionId: 'all',
			sectionSelector: false,
			topListsLoaded: false,
			productsLoaded: false,
			resetData: [],
		};
	},
	methods: {
		onTopListsLoad () {
			this.topListsLoaded = true;
			this.onPageLoad();
		},
		onProductsLoad () {
			this.productsLoaded = true;
			this.onPageLoad();
		},
		onPageLoad () {
			if (this.topListsLoaded && this.productsLoaded) {
				store.dispatch('prerender/pageLoaded');
			}
		},
		getHighlights () {
			return new Promise(resolve => {
				const data = {};

				if (this.sectionId) {
					data.sectionId = this.sectionId;
				}
				waja.get('highlight/all/' + store.getters['i18n/regionCode'])
					.data(data)
					.on('success', res => {
						this.highlights = res.data.highlights;
						resolve();
					}).go();
			});
		},
		selectSection (sectionId) {
			this.sectionSelector = false;
			if (sectionId === 'all') {
				router.push({ name: 'campaigns' });
			} else {
				router.push({ name: 'campaigns', params: { id: sectionId } });
			}
		},
		sectionIconUrl (icon) {
			return categoryIconUrl(icon);
		},
		reset () {
			// Load top lists.
			const section = this.selectedSection;
			if (store.getters['productTips/isTopListLoaded'](section)) {
				this.onTopListsLoad();
			}
			store.commit('productTips/setShowTopLists', true);
			// store.dispatch('productTips/fetchTopLists', { section }); * triggers toplist request
			store.commit('productTips/setShowLists', false);

			this.resetData = [[{
				type: 'section',
				value: section ? section.id : null,
			}], true];
			// Load highlights and popular deals.
			this.getHighlights().then(() => {
				Vue.nextTick(() => {
					if (this.highlights.length && this.$refs.highlightSection) {
						this.$refs.highlightSection.reset();
					}
				});
			});
			// Update the navigation.
			const navigationPath = [{
				title: 'Kampanjer',
				route: {
					to: 'campaigns',
					params: {
						id: null,
						title: 'Alla kampanjer - Hitta produkter till otroliga kampanjpriser',
					},
				},
				clickable: true,
			}];

			if (section) {
				metaHandler.set('description', 'Utforska alla våra nuvarande kampanjpriser i avdelnigen ' + section.name + '.');

				navigationPath[0].active = false;
				navigationPath.push({
					title: section.name,
					route: { to: 'campaigns',
						params: {
							id: section.id,
							title: section.name + ' - Missa inte våra nuvarande kampanjpriser',
						}
					},
					clickable: false,
				});
				setCustomNav({
					customPath: navigationPath,
					section,
					categories: [],
				});
			} else {
				metaHandler.set('description', 'Missa inte våra nuvarande kampanjpriser ' +
				'på vårt breda utbud av teknik, spel och produkter för hemmet.');
				setCustomNav({
					customPath: navigationPath,
				});
			}
		},
	},
	computed: {
		url () {
			const sectionId = this.selectedSection ? this.selectedSection.id : null;
			return sectionId ? 'campaigns/' + sectionId : 'campaigns';

		},
		sectionId () {
			return ~~this.$route.params.id;
		},
		selectedSection () {
			return this.sectionId ? this.sections.find(section => this.sectionId === section.id) : null;
		},
		sectionSelectorLabel () {
			return this.sectionId ? 'Välj en annan avdelning' : 'Välj en avdelning';
		},
		iconImage () {
			return convertToCdnUrl('/api/dynimg/category/kampanjer/1A1A1D');
		},
		/**
		 * Sections used for mobile navigation dropwdown
		 */
		sectionDropdownItems () {
			if (! this.sections.length) {
				return [];
			}

			const sections = [{
				label: 'Alla avdelningar',
				icon: 'kampanjer',
				value: 'all',
			}];

			for (const section of this.sections) {
				// @TODO fyndware section is hidden for now.
				if (section.id !== sectionIds.fyndwares) {
					sections.push({
						label: section.name,
						icon: section.icon,
						value: section.id,
					});
				}
			}
			return sections;
		},
		highlightsPerPage () {
			return this.mobileView ? 6 : 12;
		},
		mobileView () {
			return this.mq.current <= this.mq.md;
		},
		highlightSection () {
			return {
				name: 'Aktuella kampanjer',
				highlights: this.highlights,
			};
		},
		...mapState({
			sections: state => state.navStatus.menu.staticTree ? state.navStatus.menu.staticTree : [],
		}),
	},
	mounted () {
		bus.$on('productTips:rendered', this.onTopListsLoad);
		this.topListsLoaded = false;
		this.productsLoaded = false;
		// If the menu has been loaded, then load the campaign list.
		if (! this.sectionId) {
			this.reset();
		} else if (this.sectionId && this.selectedSection) {
			this.reset();
		}
	},
	beforeDestroy () {
		bus.$off('productTips:rendered', this.onTopListsLoad);
	},
	watch: {
		selectedSection (to, frm) {
			// Load the campaign page for a specific section, when the selected section has changed.
			if (frm && to && to.id === frm.id) {
				return;
			}
			this.topListsLoaded = false;
			this.reset();
		},
		$route (to, frm) {
			// (Prerenderer) When changing page in the product browser, the products
			// need to load before the prerendering server is notified again.
			this.productsLoaded = false;
		},
	},
};
</script>
